module.exports = __webpack_public_path__ + "img/logo-horizontal.996e32ba.svg";